/**
 * Anchor Scroll
 */
function scrollToAnchor(_selector) {
    if (_selector.indexOf("#") >= 0) {
        var anchor = $('#' + _selector.split("#")[1]);

        if (anchor && anchor.length > 0) {
            $('html, body').stop().animate({
                scrollTop: (anchor.offset().top - parseInt($('.ce-slider').css('margin-top')))
            }, 1500, 'swing');

            return true;
        }
    }
    return false;
}


/**
 * To Top Button
 */
$('.scroll-top').on('click', function (e) {
    e.preventDefault();

    $('html, body').animate({
        scrollTop: 0
    }, 1500);
});

$(window).on('scroll', function () {
    if ($(this).scrollTop() > 300) {
        $('.scroll-top').addClass('scroll-top-visible');
    } else {
        $('.scroll-top').removeClass('scroll-top-visible');
    }
});


/**
 * Anchor Scroll
 */
$('[data-link]').on('click', function (e) {
    if (scrollToAnchor($(this).attr('href'))) {
        e.preventDefault();
    }
});

if (window.location.hash) {
    scrollToAnchor(window.location.hash);
}


/**
 * Bootstrap card accordion
 */
$('.card-accordion .card-header').on('click', function (e) {
    e.preventDefault();

    $(this).toggleClass('show');
    $(this).find('.icon').toggleClass('fa-rotate-180');
});
